/**
 * Revision-round session contract shared by server and client, plus the
 * session-lifecycle wire codes the client must recognise. A revision round is
 * a practice session on an earlier-year chapter; the client sees it only
 * through this level-free projection (never a level label).
 */

/** Client-facing view of a session's revision marker. */
export interface RevisionSessionProjection {
  topicName: string;
  questionTypeName?: string;
}

/** 409 body code when a question request names a session that is no longer active. */
export const SESSION_CLOSED_CODE = 'session_closed';

/**
 * 409 body code when questions were updated (a curriculum release) while the
 * session was open. The server has already ended the session, so retrying it
 * can never succeed; the client says so and offers a way out instead.
 */
export const SESSION_STALE_CODE = 'session_stale';

/** End reason for a session closed because a start crossed the revision boundary. */
export const SESSION_END_REASON_SUPERSEDED = 'superseded';
